export default "__VITE_ASSET__BGSOYEJp__"